import template from "./order-payment-complete-page.html.twig";

Packlab.Component.register('order-payment-complete-page', {
    template,

    inject: [ 'apiClient' ],
    mixins: [ 'placeholder' ],

    data() {
        return {
            isLoading: false,
            result: null,
            customer: null
        }
    },

    created() {
        this.completeOrder();
    },

    methods: {
        completeOrder() {
            this.isLoading = true;
            this.apiClient.completeOrder(this.$route.params.orderId, this.$route.params.orderDeepLinkCode)
                .then((result) => {
                    this.result = result;
                    this.apiClient.getContext()
                        .then((context) => {
                            this.customer = context.customer;
                            window.dataLayer = window.dataLayer || [];
                            const items = [];
                            for(let i in this.result.order.orderItems) {
                                const orderItem = this.result.order.orderItems[i];
                                items.push({
                                    item_name: orderItem.label,
                                    item_id: orderItem.productNumber,
                                    price: orderItem.priceNet,
                                    discount: 0,
                                    currency: 'EUR',
                                    item_brand: 'EASY-LIZE',
                                    quantity: 1
                                });
                            }
                            window.dataLayer.push({
                                event: 'purchase',
                                ecommerce: {
                                    currency: 'EUR',
                                    value: this.result.order.priceNet,
                                    tax: this.result.order.priceTax,
                                    shipping: 0.00,
                                    payment_type: 'Rechnung',
                                    email: this.customer.email,
                                    login_type: 'I am already a customer',
                                    affiliation: '',
                                    transaction_id: this.result.order.orderNumber,
                                    coupon: '',
                                    items
                                }
                            });
                        })
                        .finally(() => this.isLoading = false );
                })
                .catch(() => this.isLoading = false );
        },
        onSaveOrder() {
            this.apiClient.getOrderPdfDeepLink(this.$route.params.orderId, this.$route.params.orderDeepLinkCode)
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = `data:application/pdf;base64,${response.contents}`;;
                    link.setAttribute('download', response.fileName);
                    document.body.appendChild(link);
                    link.click()
                })
                .catch(() => { });
        }
    }
})